module.exports = __webpack_public_path__ + "static/media/logic_wedge5.eeaf6f1a.png";